module.exports = __webpack_public_path__ + "img/logo.c027d089.png";